import { useMutation } from "@tanstack/react-query";
import { postCourseReview } from "../nodeApi/postApi/postStudentApi";
import { useToaster } from "../../shared/utils/ToasterProvider";

export const usePostCourseReview = (onSuccessCallback) => {
    const { showToaster } = useToaster();
    return useMutation({
        mutationFn: postCourseReview,
        onSuccess: (data) => {
            showToaster(data?.message || "Review submitted successfully", "", "success");
            if (onSuccessCallback) onSuccessCallback(data);
        },
        onError: (error) => {
            showToaster(error?.response?.data?.message || "Failed to submit review", "", "error");
        }
    });
};
